/**
 * formatName — normalize a person's name to Title Case for display.
 *
 * Renders the name so the first letter of every word is capitalized and the
 * rest are lowercase (e.g. "JASPRIT" / "jasprit" / "jAsPrIt" → "Jasprit",
 * "jasprit singh" → "Jasprit Singh"). Used to keep the greeting heading and the
 * top-bar / dropdown profile name visually consistent regardless of how the
 * name was stored.
 *
 * Edge cases handled:
 *  • null / undefined / non-string input → "" (never throws)
 *  • leading/trailing and repeated inner whitespace collapsed to single spaces
 *  • already upper/lower/mixed case normalized
 *  • multi-part separators — spaces, hyphens and apostrophes each start a new
 *    capitalized segment ("mary-jane" → "Mary-Jane", "d'souza" → "D'Souza")
 *  • accented Latin letters (À–ÿ / Latin-Extended-A) capitalized correctly
 */
export const toTitleCase = (value) => {
  if (value === null || value === undefined) return "";
  return String(value)
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .replace(
      /(^|[\s\-'])([a-zà-ɏ])/g,
      (_m, sep, ch) => sep + ch.toUpperCase()
    );
};

export default toTitleCase;
